/**
 * Project Name : cop-web-portal
 * File Name : MFAUtils.js
 * Description : MFA Util
 * Author : dhoop.lee
 * Date : 2023.5.25
 */
import axios from 'axios';
import { SDLUtil } from '@/utils';


// const toBlackList = ['/mfa/request'];
/**
 * MFA 제외 Path
 */

const fromPublicPages = ['/login', '/logout', '/mfa/responser', '/register', '/initPassword', '/terms-conditions', '/noauth', '/404', '/userSignup', '/maintenance'];
const toPublicPages = fromPublicPages.concat(['/warning']);
/**
* param MFA Token from LocalStorage
* return resolve(Boolean)
* exception
* description MFA Token 확인 Promise
* since 2023-05-30
*/
const isMFAAuthorized = () => {
  return axios.get(`${SDLUtil.API_URL}/mfa/validate`);
};
/**
* param MFA Token
* return resolve()
* exception
* description MFA Token Set
* since 2023-05-30
*/
const setMFAToken = (token) => {
  localStorage.setItem('MFAToken', token);
  return Promise.resolve();
};
/**
* param
* return MFA Token
* exception
* description get MFA Token From LocalStorage
* since 2023-05-30
*/
const getMFAToken = () => localStorage.getItem('MFAToken');
/**
* param null
* return null
* exception
* description remove MFA Token from LoaclStorage
* since 2023-05-30
*/
const removeMFAToken = () => localStorage.removeItem('MFAToken');
/**
* param
* return MFA Authorize Result resolve(Boolean)
* exception
* description MFA 인증 팝업
* since 2023-05-30
*/
const showMFAPopup = () => new Promise((resolve) => {
  removeMFAToken();
  axios
    .get(`${SDLUtil.API_URL}/mfa/second-auth?redirection=popup`)
    .then((resp) => {
      const popup = window.open(resp.data, '', 'width=750, height=10000, left=500');
      const detectPopupTimer = setInterval(() => {
        SDLUtil.showLoadingBar(true);
        if (popup.closed) {
          clearInterval(detectPopupTimer);
          isMFAAuthorized().then(({ data }) => {
            if (data === true) {
              const mfaToken = SDLUtil.parseJwt(localStorage.getItem('MFAToken'));
              SDLUtil.showLoadingBar(false);
              if (mfaToken.ret === '1') {
                // 인증 성공
                return resolve(true);
              }
              // 인증 실패
              removeMFAToken();

              SDLUtil.alert(
                {
                  msg: mfaToken.msg,
                  onOkEvt: () => resolve(false),
                },
              );
            } else {
              // 사용자가 팝업을 인증 없이 닫은 경우
              resolve(false);
            }
            SDLUtil.showLoadingBar(false);
          });
        }
      }, 1000);
    });
});
/**
* param path
* return redirect to MFA
* exception
* description MFA 인증 페이지 이동
* since 2023-05-30
*/
const redirectToMFA = (path) => {
  removeMFAToken();
  axios
    .get(`${SDLUtil.API_URL}/mfa/second-auth?redirection=${path}`)
    .then((resp) => {
      window.location.href = resp.data;
    });
};
/**
* param to, from
* return Promise.resolve(boolean)
* exception
* description MFA Redirect 체크
* since 2023-09-17
*/
const checkMFAUrl = (to, from) => {
  return SDLUtil.isLogin()
    && !toPublicPages.includes(to.path)
    && !fromPublicPages.includes(from.path)
    // && process.env.NODE_ENV !== 'dev' 임시 주석 soonh94.hong
    && !axios.defaults.headers.common['original-user-id'];
};
/**
* param router to, router from, router next
* return redirct to next after MFA
* exception MFA Fail => Logout Page
* description router/index.js Interceptor local 혹은 대리로그인 혹은 public page가 아닌 경우 MFA Redirect
* since 2023-05-30
*/
const getMFAAuthorizeByUrl = async (to, from, next) => {
  if (checkMFAUrl(to, from)) {
    isMFAAuthorized().then(({ data }) => {
      if (!data) {
        redirectToMFA(to.fullPath);
        return next(false);
      }
      return next();
    });
  } else return next();
};

export default {
  isMFAAuthorized,
  getMFAAuthorizeByUrl,
  setMFAToken,
  showMFAPopup,
  getMFAToken,
  removeMFAToken,
  redirectToMFA,
};



// WEBPACK FOOTER //
// ./src/utils/MFAUtil.js